<script setup lang="ts">
import { IAlarmByClassification, IAlarmBySensor, IAlarmByType } from '@/interfaces/stores/alarm'
import { useAlarmStore } from '@/store/alarm'
import { useReportStore } from '@/store/report'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import AlarmReportChart from '@/components/Alarms/Body/Chart/AlarmReportChart.vue'

const { t } = useI18n()

const { getCompareAlarmReportMetrics, getBaseAlarmReportMetrics } = storeToRefs(useAlarmStore())
const { hasBaseAlarmReportMetrics, hasCompareAlarmReportMetrics } = storeToRefs(useAlarmStore())
const { showAlarmReportBase, showAlarmReportCompare } = storeToRefs(useReportStore())
</script>

<template>
  <div
    v-if="hasBaseAlarmReportMetrics && showAlarmReportBase"
    class="grid grid-cols-1 grid-rows-2 gap-6 lg:grid lg:grid-flow-row lg:grid-cols-2 lg:grid-rows-2">
    <AlarmReportChart
      id="chart"
      :chart-title="t('alarm_report.body.result.charts.by_sensor.title') + ' base'"
      :chart-type="'alarm-report-by-sensor-chart'"
      :readings="getBaseAlarmReportMetrics.alarms_by_sensor as IAlarmBySensor[]" />

    <AlarmReportChart
      :chart-title="t('alarm_report.body.result.charts.by_type.title') + ' base'"
      :chart-type="'alarm-report-by-type-chart'"
      :readings="getBaseAlarmReportMetrics.alarms_by_type as IAlarmByType[]" />

    <AlarmReportChart
      :chart-title="t('alarm_report.body.result.charts.by_classification.title') + ' base'"
      :chart-type="'alarm-report-by-classification-chart'"
      :readings="getBaseAlarmReportMetrics.alarms_by_classification as IAlarmByClassification[]" />
  </div>
  <div
    v-if="hasCompareAlarmReportMetrics && showAlarmReportCompare"
    class="grid grid-cols-1 grid-rows-2 gap-6 lg:grid lg:grid-flow-row lg:grid-cols-2 lg:grid-rows-2">
    <AlarmReportChart
      id="chart"
      :chart-title="t('alarm_report.body.result.charts.by_sensor.title') + ' comparação'"
      :chart-type="'alarm-report-by-sensor-chart'"
      :readings="getCompareAlarmReportMetrics.alarms_by_sensor as IAlarmBySensor[]" />

    <AlarmReportChart
      :chart-title="t('alarm_report.body.result.charts.by_type.title') + ' comparação'"
      :chart-type="'alarm-report-by-type-chart'"
      :readings="getCompareAlarmReportMetrics.alarms_by_type as IAlarmByType[]" />

    <AlarmReportChart
      :chart-title="t('alarm_report.body.result.charts.by_classification.title') + ' comparação'"
      :chart-type="'alarm-report-by-classification-chart'"
      :readings="getCompareAlarmReportMetrics.alarms_by_classification as IAlarmByClassification[]" />
  </div>
</template>
